import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Area Range chart type
 * Extends the base chart configuration
 * Requires the highcharts-more module
 */
export const arearangeChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'arearange'
    },
    plotOptions: {
        arearange: {
            lineWidth: 1,
            marker: {
                enabled: false
            },
            fillOpacity: 0.3,
            states: {
                hover: {
                    lineWidth: 1
                }
            }
        }
    },
    tooltip: {
        crosshairs: true,
        shared: true,
        valueDecimals: 2,
        headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
        pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.low} - {point.high}</b><br/>'
    },
    // For range charts, we often want to show both axes
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b'
        }
    }
} as Options);